import { Gender } from "@entities/common";

export enum RoleType {
  JOB_SEEKER = "job_seeker",
  EMPLOYER = "employer",
  ADMIN = "admin",
  ADMIN_PROVINCE = "admin_province",
  ADMIN_CITY = "admin_city",
}

export type Profile = {
  id: string;
  status: "new" | "completed";
  lookingForJob: boolean;
  lookingForJobProcessing: boolean;
  skills: { id: string; key: string; name: string }[];
  domicileRegion: any;
  phone: string;
  pob: string;
  bod: string;
  gender: Gender;
  identityVillageId: string;
}

export type User = {
  createdAt: string;
  email: string;
  id: string;
  nacoUserId: string;
  name: string;
  roles: { id: string; name: RoleType; label: string }[];
  status: string;
  updatedAt: string;
  username: string;
  profile: Profile;
}